var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPromote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53301 3.99894L13.0999 1.38927C13.1444 1.36387 13.1997 1.39596 13.1997 1.44715V12.1065V12.2102C13.1997 12.2629 13.1413 12.2948 13.097 12.2662L8.53301 9.33227V3.99894ZM8.23931 10.3323L12.5562 13.1074C13.2661 13.5638 14.1997 13.0541 14.1997 12.2102V8.99763C15.0892 8.96264 15.7997 8.23042 15.7997 7.33227V5.99894C15.7997 5.10079 15.0892 4.36857 14.1997 4.33358V1.44715C14.1997 0.628156 13.3149 0.114673 12.6038 0.521024L8.26744 2.99894H3.99967C1.97463 2.99894 0.333008 4.64056 0.333008 6.66561C0.333008 8.57733 1.79605 10.1473 3.66354 10.3171L4.33488 15.0165C4.40995 15.542 4.86 15.9323 5.39083 15.9323H7.24463C7.9533 15.9323 8.46494 15.254 8.27025 14.5726L7.05874 10.3323H8.23931ZM5.99967 10.2656H4.66634L5.32483 14.875C5.32952 14.9079 5.35765 14.9323 5.39083 14.9323H7.24463C7.28892 14.9323 7.3209 14.8899 7.30873 14.8473L5.99967 10.2656ZM7.59967 9.33227V3.99894H3.99967C2.52692 3.99894 1.33301 5.19285 1.33301 6.66561C1.33301 7.97342 2.27446 9.06135 3.51662 9.28863C3.67328 9.3173 3.83473 9.33227 3.99968 9.33227H7.59967ZM14.1997 7.99565C14.5366 7.9622 14.7997 7.67796 14.7997 7.33227V5.99894C14.7997 5.65325 14.5366 5.36901 14.1997 5.33556C14.1777 5.33339 14.1555 5.33227 14.133 5.33227V7.99894C14.1555 7.99894 14.1777 7.99782 14.1997 7.99565Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromote);
export default __webpack_public_path__ + "static/media/promote.7d2b78d07425cc275d28c82bd1344628.svg";
export { ForwardRef as ReactComponent };